import "./StartYourBuild.module.css";
import Header from "@/reusable_sections/Header";
import PartnerWithUs from "./sections/PartnerWithUs";
import CommonQuestions from "./sections/CommonQuestions";
import InnovationHeadquarters from "./sections/InnovationHeadquarters";
import Footer from "@/reusable_sections/Footer";
export default function StartYourBuildPage() {
  return <div>
      <Header />
      <PartnerWithUs />
      <CommonQuestions />
      <InnovationHeadquarters />
      <Footer />
    </div>;
}